/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Upgrade_Preview_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to preview upgrade." |
*
* @param {Plan_Upgrade_Preview_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_upgrade_preview_error = /** @type {((inputs?: Plan_Upgrade_Preview_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Upgrade_Preview_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upgrade-Vorschau fehlgeschlagen.")
	return /** @type {LocalizedString} */ ("Failed to preview upgrade.")
});